// extracted by mini-css-extract-plugin
export default {"wrapper":"Document_wrapper__keL+8","section":"Document_section__f+4by","content":"Document_content__bMXEA","loader_wrapper":"Document_loader_wrapper__D3Ow+"};